const state = {
  main: 1
}

const mutations = {
  DECREMENT_MAIN_COUNTER (state) {
    state.main--
  },
  INCREMENT_MAIN_COUNTER (state) {
    state.main++
  },
  RESET_MAIN_COUNTER (state) {
    state.main = 1
  }
}

const actions = {
  reConnectCounter ({ commit }) {
    // do something async
    commit('INCREMENT_MAIN_COUNTER')
  },
  resetCounter ({ commit }) {
    // do something async
    commit('RESET_MAIN_COUNTER')
  }
}

export default {
  state,
  mutations,
  actions
}
